import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { chanceOrderCount } from '../../../modules/chanceModule/chance';
import { listPartnerEmployees } from '../../../modules/partnerModule/employees';
import DetailTemplate from '../../common/template/DetailTemplate';
import EstimateListContainer from '../../../containers/chancemng/estimate/EstimateListContainer';
import EstimateModal from '../estimate/EstimateModal';

const EstimateTemplate = () => {
  const dispatch = useDispatch();
  const { chance, orderCount, vendorEmps } = useSelector(
    ({ chanceModule, partnerModule }) => ({
      chance: chanceModule.chance.chance,
      orderCount: chanceModule.chance.orderCount,
      vendorEmps: partnerModule.partnerEmployees.employees,
    }),
  );

  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setData(null);
  };

  const editFunction = (params) => {
    //console.log(params, 'parent');
    setData(params);
    setOpen(true);
  };

  useEffect(() => {
    if (chance) {
      dispatch(chanceOrderCount(chance.prjUuid));
      dispatch(listPartnerEmployees(chance.vendorCmp));

      // console.log(chance?.costYn);
    }
  }, [chance]);

  if (!chance) {
    return null;
  }

  return (
    <Box>
      <DetailTemplate title="견적 리스트">
        <EstimateListContainer editFunction={editFunction} />
      </DetailTemplate>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        {chance && Number(chance?.cstGrade) >= 3 && (
          <Button
            variant="outlined"
            color="success"
            onClick={handleOpen}
            sx={{ mr: 1 }}
          >
            견적서 작성
          </Button>
        )}
      </Box>
      <EstimateModal
        chance={chance}
        type={data != null ? 'edit' : 'add'}
        estimate={data}
        open={open}
        orderCount={orderCount}
        vendorEmps={vendorEmps}
        handleClose={handleClose}
      />
    </Box>
  );
};

export default EstimateTemplate;
